import type { ReactElement } from "react";
import type { RouteObject } from "react-router-dom";
import { CommissionPage } from "./CommissionPage";
import { MonthPage } from "./MonthPage";
import { MyCommissionPage } from "./MyCommissionPage";
import { MyPayslipsPage, PayslipPage } from "./PayslipPage";
import { PayrollPage } from "./PayrollPage";
import { RequireView } from "./kit";
import { areaAllows } from "../../app/nav";
import { commissionAllows } from "./CommissionPage";

const pay = (el: ReactElement) => <RequireView allow={(h) => areaAllows("payroll", h)}>{el}</RequireView>;

/** Payroll, commission and the caller's own pay pages. `/payroll/payslips/:id` and `/payroll/commission` are static, so they outrank `/payroll/:month`. */
export const routes: RouteObject[] = [
  { path: "payroll", element: pay(<PayrollPage />) },
  { path: "payroll/commission", element: <RequireView allow={commissionAllows}><CommissionPage /></RequireView> },
  { path: "payroll/payslips/:id", element: pay(<PayslipPage />) },
  { path: "payroll/:month", element: pay(<MonthPage />) },
  { path: "me/payslips", element: <MyPayslipsPage /> },
  { path: "me/payslips/:id", element: <PayslipPage own /> },
  { path: "me/commission", element: <MyCommissionPage /> },
];
